module.exports = __webpack_public_path__ + "img/blue_bay_bath_302.28ee6d06.jpeg";